export const AndroidImportance = { HIGH: 4 };
export const EventType = { PRESS: 1 };

const notifee = {
  requestPermission: async () => {},
  createChannel: async () => 'default',
  displayNotification: async () => {},
  setBadgeCount: async () => {},
  cancelDisplayedNotifications: async () => {},
  onForegroundEvent: () => () => {}
};

export default notifee;
